module.exports = __webpack_public_path__ + "static/img/scene2.e42a81a3.png";